import { forwardRef } from 'react';
import * as views from './Hero.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Hero = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      _ref$copyVariant = _ref.copyVariant,
      copyVariant = _ref$copyVariant === void 0 ? "wide" : _ref$copyVariant,
      children = _ref.children,
      className = _ref.className;
  return _jsx(views.Container, {
    className: className,
    children: _jsx(views.Wrapper, {
      ref: ref,
      variant: variant,
      copyVariant: copyVariant,
      children: children
    })
  });
});
export default Hero;